import React from 'react'
import PropTypes from 'prop-types'
import cssModules from 'react-css-modules'
import styles from './create_type.less'
import { getI18n } from 'client/i18n'
import { sendEnsightenEvent } from 'lib/ensighten_analytics'
import { Link } from 'react-router'
import { glimpseRoute } from 'lib/route_utils'
import { Icon, HeadingText } from '@paypalcorp/pp-react'

export const I18N_CONTEXT = 'components/pages/create/pool_type'
const i18n = getI18n(I18N_CONTEXT)

class PoolType extends React.Component {
  static propTypes = {
    formattedMaxGoalAmount: PropTypes.string,
    isBusinessAccount: PropTypes.bool,
  }

  componentDidMount() {
    sendEnsightenEvent('MoneyPoolStart')
  }

  render() {
    return (
      <div>
        <HeadingText size="md" styleName="title">
          {i18n('title')}
        </HeadingText>
        <div styleName="content-wrapper">
          <Icon name="money-pools" size="sm" styleName="content-icon" />
          <div
            dangerouslySetInnerHTML={{
              __html: i18n('campaign_description'),
            }}
          />
        </div>
        <div styleName="content-wrapper">
          <Icon name="share" size="sm" styleName="content-icon" />
          <div
            dangerouslySetInnerHTML={{
              __html: i18n('share_description'),
            }}
          />
        </div>
        <div styleName="content-wrapper">
          <Icon name="transfer-money" size="sm" styleName="content-icon" />
          <div
            dangerouslySetInnerHTML={{
              __html: i18n('donation_description'),
            }}
          />
        </div>
        <div styleName="disclaimer">
          {i18n('disclaimer', {
            maxGoalAmount: this.props.formattedMaxGoalAmount,
          })}
        </div>
        <Link
          to={glimpseRoute('create-crowdfunding', 'basics', 'create')}
          className="vx_btn vx_btn-block"
          styleName="button-cf"
          data-pa-click="crowdfunding"
          data-nemo="crowdfunding-pool-link"
        >
          {i18n('create_your_page')}
        </Link>
        {!this.props.isBusinessAccount && (
          <Link
            to={glimpseRoute('create', 'basics')}
            styleName="link"
            data-pa-click="moneypool"
            data-nemo="standard-pool-link"
          >
            {i18n('create_unrelated_page')}
          </Link>
        )}
      </div>
    )
  }
}

export default cssModules(PoolType, styles)
